<template>
  <div class="header-container full-width">
    <h4>
      <a href="#" @click.prevent="redirectToReport">{{ title }}</a>
    </h4>
    <div class="utility-container">
      <ToggleSwitch v-model="cumulative" class="toggle" label-on="Cumulative" />
      <Tooltip>
        <template #trigger>
          <i class="fas fa-info-circle"></i>
        </template>
        <template #tooltip>
          <div>{{ tooltipText }}</div>
        </template>
      </Tooltip>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip,
    ToggleSwitch
  },
  props: {
    reportUrl: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    tooltipText: {
      type: String,
      default: ""
    }
  },
  emits: ["cumulative-change"],
  data() {
    return {
      cumulative: true
    };
  },
  watch: {
    cumulative(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("cumulative-change", newValue);
      }
    }
  },
  methods: {
    redirectToReport() {
      const parsedUrl = new URL(this.reportUrl);
      const { pathname, search } = parsedUrl;
      this.$router.push(pathname + search);
    }
  }
};
</script>

<style lang="scss" scoped>
.utility-container {
  display: flex;
  width: 30%;
  justify-content: flex-end;
  .toggle {
    font-size: 0.7rem;
    margin-right: 2rem;
  }
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
